export { default } from './AccordionDetailsEdit';
